import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';

const content = {
  en: {
    title: "Grand Opening Celebration",
    subtitle: "Exclusive First Visit Offer",
    description: "Experience our premium aesthetic services\nwith 25% off everything\non your first visit\nComplimentary consultation included\nExcludes advanced injection and thread lifting services",
    highlight: "25% OFF",
    cta: "Book Your Appointment"
  },
  cn: {
    title: "开业庆典",
    subtitle: "首次到访专享",
    description: "体验我们的高端医美服务\n首次到访享受全场\n25% 优惠\n免费咨询包含在内\n不包括高级注射和线雕服务",
    highlight: "25% 优惠",
    cta: "立即预约"
  }
};

const PopupAd = ({ delay = 2000 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { lang } = useLang();
  const navigate = useNavigate();
  const c = content[lang];

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('hasSeenPopup');
    
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [delay]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('hasSeenPopup', 'true');
  };

  const handleBookNow = () => {
    navigate('/book-form');
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-0">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={handleClose}
      />
      
      {/* Popup Content */}
      <div className="relative w-full max-w-lg transform rounded-2xl bg-gradient-to-br from-[#fdf6e9] to-[#f5ede0] p-8 shadow-2xl transition-all animate-fadeIn border border-champagne/40">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute right-4 top-4 text-brown-600 hover:text-brown-800 transition-colors z-10"
          aria-label="Close"
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Content */}
        <div className="text-center space-y-6">
          {/* Main Title */}
          <div className="space-y-2">
            <h2 className="text-3xl md:text-4xl font-bold text-brown-800 leading-tight">
              {c.title}
            </h2>
            <div className="inline-block px-4 py-1.5 bg-[#2E6B4C]/10 rounded-full">
              <p className="text-sm font-semibold text-[#2E6B4C]">{c.subtitle}</p>
            </div>
          </div>

          {/* Highlight Badge */}
          <div className="relative inline-block">
            <div className="absolute inset-0 bg-gradient-to-r from-[#2E6B4C]/20 to-[#2E6B4C]/10 rounded-full blur-xl"></div>
            <div className="relative bg-gradient-to-br from-[#2E6B4C] to-[#1f4a35] text-white px-8 py-4 rounded-2xl shadow-lg">
              <p className="text-4xl md:text-5xl font-bold tracking-tight">{c.highlight}</p>
            </div>
          </div>

          {/* Description */}
          <p className="text-brown-700 whitespace-pre-line text-lg leading-relaxed max-w-sm mx-auto font-medium">
            {c.description}
          </p>

          {/* CTA Button */}
          <button
            onClick={handleBookNow}
            className="w-full max-w-xs mx-auto mt-4 px-6 py-3 rounded-xl shadow-soft transition-all text-gray-900 hover:shadow-glow hover:brightness-110 border border-champagne/60 font-semibold text-lg"
            style={{
              backgroundImage:
                'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
            }}
          >
            {c.cta}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupAd;